import apiHandler from "./apiHandler";



const apiAirport = {
  details: (icao) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/airport/${icao}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  // getTraffic: (icao) => {
  //   return new Promise((resolve, reject) => {
  //     apiHandler
  //       .get(`/airport/${icao}/traffic`)
  //       .then((response) => {
  //         resolve(response.data);
  //       })
  //       .catch((err) => {
  //         console.error(err);
  //         error(
  //           err.response !== undefined
  //             ? err.response.data.message
  //             : "Error occured"
  //         );
  //         reject(
  //           err.response !== undefined
  //             ? err.response.data.message
  //             : "Error occured"
  //         );
  //       });
  //   });
  // },
  getForMap: (lat1, lon1, lat2, lon2, order = "normal") => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/airport/map/${lat1}/${lon1}/${lat2}/${lon2}/${order}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default apiAirport;
